var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-to-cart" }, [
    !_vm.slim
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.quantity,
              expression: "quantity"
            }
          ],
          attrs: { type: "number", min: "1" },
          domProps: { value: _vm.quantity },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.quantity = $event.target.value
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("a", {
      domProps: { textContent: _vm._s(_vm.btnText) },
      on: { click: _vm.addToCart }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }